import axios from "./axios";
import config from "./config";
import carriers from "./carriers";
import common from './common';
import rebuild from './rebuild';
const http = {
  //密码登陆
  loginPwd(data) {
    return axios.post("/driver/login/pwd", data);
  },
  //验证码登录
  loginCode(data) {
    return axios.post("/driver/login/code", data);
  },
  //手机验证码
  getCode(data) {
    return axios.get("/driver/code", {
      params: data
    });
  },
  // 手机号找回密码
  phoneFindPwd(data) {
      return axios.post("/driver/retrievePwd/phone/",data)
  },
  //获取用户信息
  getUserInfo() {
    return axios.get("/driver/info");
  },
  //注册司机
  registerDriver(data) {
    return axios.post("/driver/register/DRIVER/0", data);
  },
  //注册货主
  registerCustomer(data) {
    return axios.post("/driver/register/CUSTOMER/0", data);
  },
  //注册承运商
  registerCarrier(data) {
    return axios.post("/driver/register/CARRIERS/0", data);
  },
  // 通用下拉列表
  selectList(data) {
    return axios.get("/dictionary/select/" + data);
  },
  // 司机认证
  driverAuth(data) {
    return axios.post("/driver/auth", data);
  },
  //承运商认证
  commitAuthCarrier(data) {
    return axios.post("/carrier/commitAuthCarrier", data);
  },
  // 货主认证
  commitAuthCustomer(data) {
    return axios.post("/carrier/commitAuthCustomer", data);
  },
  //获取认证信息
  driverUserInfo() {
    return axios.get("/carrier/getAuth");
  },
  //获取收货地址
  addressList(data) {
    return axios.get("/ythDemand/position/list", {
      params: data
    });
  },
  // 新增地址
  addAddress(data) {
    return axios.post("/ythCustomer/addPosition", data);
  },
  // 获取货物列表
  getGoodsList(data) {
    return axios.get("/ythDemand/getGoodsList", {
      params: data
    });
  },
  // 获取货物列表
  getPackgeList(data) {
    return axios.get("/ythDemand/getPackgeList", {
      params: data
    });
  },
  // 新建需求单
  addDemand(data) {
    return axios.post("/ythDemand/addDemand", data);
  },
  // 根据上级地区获取下级地区
  getAllCity(data) {
    return axios.get("/ythAddress/getAllCity", {
      params: data
    });
  },
  // 获取运输单列表
  orderList(data) {
    return axios.post("/ythTransport/findList", data);
  },
  // 获取运输单详情
  orderDetail(id) {
    return axios.get("/ythTransport/detail/" + id);
  },
  // 获取运输单回单信息
  getReturn(id) {
    return axios.get("/ythTransport/getReturn/" + id);
  },
  // 运输单货主审核回单
  approveConfirm(data) {
    return axios.post("/ythAdmin/ythTransport/approveConfirm", data);
  },
  // 运输单承运商回单确认
  confirmReceipt(data) {
    return axios.post("/ythTransport/confirmReceipt", data);
  },
  // 货源列表搜索
  supplyList(data) {
    return axios.post("/pc/ythSupplyOfGoods/list", data);
  },
  // 货源详情
  supplyDetail(data) {
    return axios.get("/pc/ythSupplyOfGoods/detail", {
      params: data
    });
  },
  // 路线列表搜索
  routeList(data) {
    return axios.post("/pc/YthRoute/list", data);
  },
  // 车源下拉
  dropDownList(data) {
    return axios.get("/pc/car/dropDownList", {
      params: data
    });
  },
  // 车源列表搜索
  carList(data) {
    return axios.post("/pc/car/getList", data);
  },
  // 帮助中心搜索
  contentSearch(data) {
    return axios.post("/content/search", data);
  },
  // 操作手册
  operationManualList(data) {
    return axios.post("/content/operationManual/list", data);
  },
  // 批量导入司机模板
  driverTemplate: config.baseUrl + "/yth/import/driver/template?token=",
  //批量导入车辆模板
  carTemplate: config.baseUrl + "/ythAdmin/ythCar/import/template?token=",
  // 导入司机
  driverImport(data) {
    return axios.post("/yth/import/driver/import", data);
  },
  // 导入车辆
  carImport(data) {
    return axios.post("/ythAdmin/ythCar/car/import", data);
  },
  // 货主需求单列表
  demadList(data) {
    return axios.post("/ythDemand/customer/myOrder", data);
  },
  // 货主需求单详情
  demadDetail(data) {
    return axios.get("/ythDemand/customer/detail", {
      params: data
    });
  },
  // 货主发布委派单
  customerPublish(data) {
    return axios.post("/ythDemand/customer/publish", data);
  },
  // 货主取消委派单
  customerCancel(data) {
    return axios.post("/ythDemand/customer/cancel", data);
  },
  // 获取共享池数据
  getShareDataList(data) {
    return axios.post("/shareData/getShareDataList", data);
  },
  // 根据物料编号推测物料信息-备注：lyl
  getgetByItemMaterielNo(data) {
    return axios.get("/dictionary/getByItemMaterielNo", {
      params: data
    });
  },
  //货物特性查询/性状查询/货物品名查询/货物类别查询备注：lyl
  getNewShareDataList(url, params) {
    return axios({
      url,
      params
    });
  },
  // 获取委派单详情
  consignmentNoteDetail(data) {
    return axios.get("/yth/consignmentNote/customer/detail", {
      params: data
    });
  },
  // 获取需求单的询价列表
  customerFindList(data) {
    return axios.post("/ythQuote/customer/findList", data);
  },
  // 确认平台报价
  confirmPlatformQuote(data) {
    return axios.get("/ythDemand/demand/confirmPlatformQuote", {
      params: data
    });
  },
  // 拒绝平台报价
  refusePlatformQuote(data) {
    return axios.get("/subDemand/refusePlatformQuote", {
      params: data
    });
  },
  // 获取需求单对应委派单列表
  customerMyOrder(data) {
    return axios.post("/yth/consignmentNote/customer/myOrder", data);
  },
  //  创建委派单
  addConsignmentNote(data) {
    return axios.post("/yth/consignmentNote/addConsignmentNote", data);
  },
  // 取消委派单
  consignmentNoteCancel(data) {
    return axios.post("/yth/consignmentNote/cancel", data);
  },
  // 发布委派单
  consignmentNotePublish(data) {
    return axios.post("/yth/consignmentNote/customer/publish", data);
  },
  // 获取可结算单列表
  commonDemand(data) {
    return axios.post("/delegate/common/liquidation", data);
  },
  // 获取结算单列表
  appList(data) {
    return axios.get("/reconciliation/app/list", {
      params: data
    });
  },
  // 获取结算单详细
  appReList(data) {
    return axios.get("/reconciliation/app/relist", {
      params: data
    });
  },
  // 货主/承运商审核结算单
  reconciliationApproval(data) {
    return axios.get("/reconciliation/approval/" + data, {});
  },
  // 执行方发起对账
  doCheckCus(data) {
    return axios.post("/reconciliation/doCheck/cus", data);
  },
  // 创建发票
  ticketFounded(data) {
    return axios.post("/ticket/founded", data);
  },
  // 获取结算单对应发票列表
  invoiceList(data) {
    return axios.post("/ticket/app/list", data);
  },
  // 通过发票获取结算单详细
  ticketDetails(data) {
    return axios.get("/ticket/app/details", {
      params: data
    });
  },
  // 货主发起结算
  reconciliationCustomer(data) {
    return axios.post("/reconciliation/customer/with/customer", data);
  },
  // 司机审核结算单
  specialApproval(data) {
    return axios.post("/reconciliation/special/approvals", data);
  },
  // 司机上传发票
  ticketInvoicing(data) {
    return axios.get("/reconciliation/ticket/invoicing/user", {
      params: data
    });
  },
  // 司机确认接单---针对已分配的订单
  receiveOrder(data) {
    return axios.post("/ythTransport/confirmReceivingOrders", data);
  },
  // 司机拒绝接单---针对已分配的订单
  driverRejectOrder(data) {
    return axios.get("/ythTransport/refuseOrder", { params: data });
  },
  // 司机到达启运点
  arriveDeparturePoint(data) {
    return axios.post("/ythTransport/arriveDeparturePoint", data);
  },
  // 退回类型列表
  backTypeList() {
    return axios.get("/dictionary/select/BACK_SEND_TYPE");
  },
  // 司机退回发货
  driverBackGoods(data) {
    return axios.post("/ythTransport/cancelOrder", data);
  },
  // 司机确认发货
  deliverGoods(data) {
    return axios.post("/ythTransport/deliverGoods", data);
  },
  // 司机确认签收
  receiptConfirm(data) {
    return axios.post("/ythTransport/receiptConfim", data);
  },
  // 拒收类型列表
  rejectTypeList() {
    return axios.get("/dictionary/select/REFUSE_RECEIVE_TYPE");
  },
  // 司机拒收
  driverRefuse(data) {
    return axios.post("/ythTransport/refuse", data);
  },
  // 异常类型列表
  // abnormalTypeList() {
  //     return axios.get("/ythTransport/error/list/event")
  // },
  abnormalTypeList() {
    return axios.get("/dictionary/select/event");
  },
  // 异常原因列表
  // abnormalWhyList(data) {
  //     return axios.get("/ythTransport/error/list/reason", { params: data })
  // },
  abnormalWhyList(data) {
    return axios.get("/dictionary/select/reason", { params: data });
  },
  // 异常汇报
  abnormalSubmit(data) {
    return axios.post("/ythTransport/errorSubmit", data);
  },
  // 投诉类型列表
  adviceTypeList() {
    return axios.get("/advice/getAdviceType");
  },
  // 投诉
  complaintsSubmit(data) {
    return axios.post("/advice/addAdvice", data);
  },
  // 司机对承运商发起结算
  driverWithDriver(data) {
    return axios.post("/reconciliation/driver/with/driver", data);
  },
  // 子账户列表
  subAccountList(data) {
    return axios.post("/ythSubAccount/findList", data);
  },
  // 子账户删除
  subAccountDel(data) {
    return axios.get("/ythSubAccount/delete/" + data);
  },
  // 子账户管理-绑定主账号-获取货主列表
  getCustomerList(data) {
    return axios.post("/ythAdmin/ythCarrier/customerList", data);
  },
  // 子账户管理-绑定主账号-获取承运商列表
  ythAdminythCarriercarrierList(data) {
    return axios.post("/ythAdmin/ythCarrier/carrierList", data);
  },
  // 子账户绑定主账户申请
  ythSubAccountapply(data) {
    return axios.post("/ythSubAccount/apply", data);
  },
  // 查看子账户绑定申请列表
  selectSubAccountApply(data) {
    return axios.get("/ythSubAccount/selectSubAccountApply", { params: data });
  },
  // 主账户审核子账户绑定申请
  ythSubAccountactionApply(data) {
    return axios.post("/ythSubAccount/actionApply", data);
  },
  // 查看绑定主账户申请状态
  ythSubAccountcheckApplyStatus() {
    return axios.get("/ythSubAccount/checkApplyStatus");
  },
  // 子账号和主账号显示不同的标题
  getdriverinfo() {
    return axios.get("/driver/info");
  },
  // 司机新建车辆提交审核
  createCarSubmit(data) {
    return axios.post("/ythNfpCar/auth", data);
  },

  // 获取车牌颜色列表
  getCardColorList() {
    return axios.get("/dictionary/select/color");
  },
  // 能源类型列表
  getEnergyTypeList() {
    return axios.get("/dictionary/select/energy_types");
  },
  // 保险公司列表列表
  getInsuranceCompanyList() {
    return axios.get("/dictionary/select/insurance_company");
  },
  // 车辆类型列表
  getCardMethodList(data) {
    return axios.post("/ythAdmin/ythCar/getCarType", data);
  },
  // 车辆尺寸列表
  carSizeList(data) {
    return axios.get("/dictionary/select/" + data);
  },
  // 货主获取运输方式
  transport_way() {
    return axios.get("/dictionary/select/transport_way");
  },
  // 协议
  getClause(data) {
    return axios.get("/content/getClause", { params: data });
  },
  // 空车列表
  emptyCarList(data) {
    return axios.post("/ythAdmin/emptyCar/list", data);
  },
  // 需求单列表--公共
  ythDemandList(data) {
    return axios.get("/demand/ythDemand/list", { params: data });
  },
  // 显示平台信息
  statisticsPlus(data) {
    return axios.get("/ythAdmin/statistics/plus");
  },
  // 司机承运商修改车辆信息
  ythNfpCarModify(data) {
    return axios.post("/ythNfpCar/modify", data);
  },
  // 冻结车辆
  ythNfpCarDelete(data) {
    return axios.get("/ythNfpCar/delete", { params: data });
  },
  // 查询车辆是否存在系统
  ythNfpCarHasCarNumber(data) {
    return axios.get("/ythNfpCar/hasCarNumber", { params: data });
  },
  // 系统已存在车辆发起解绑
  ythNfpCarUnBinding(data) {
    return axios.get("/ythNfpCar/unBinding", { params: data });
  },
  // 承运商获取司机报价
  getDriverQuote(data) {
    return axios.post("/ythTransport/getDriverQuote", data);
  },
  // 承运商选择报价司机运输
  carrierChoiceDriver(data) {
    return axios.post("/ythTransport/carrierChoiceDriver", data);
  },
  // 空车发布
  carPublish(data) {
    return axios.post("/emptyCar/publish", data);
  },
  // 获取空车列表
  getEmptyCarList(data) {
    return axios.post("/ythNfpCar/car/getEmptyCarList", data);
  },

  // 子账号获取角色类型
  roleTypeList(data) {
    return axios.get("/ythSubAccount/roleTypeList", {
      params: data
    });
  },
  // 子账号新增/修改
  subAccountEdit(data) {
    return axios.post("/ythSubAccount/save", data);
  },
  // 待货主确认修改 （平台修改了需求单，待货主确认）
  confirmPlatformUpdate(data) {
    return axios.get("/ythDemand/confirmPlatformUpdate", { params: data });
  },
  // 货主确认/拒绝 平台修改
  actionPlatformUpdate(data) {
    return axios.post("/subDemand/actionPlatformUpdate", data);
  },
  // 获取各省份注册人数
  getGegisterNum(data) {
    return axios.get("/platform/info/register", { params: data });
  },
  // 主页交易信息
  getHomeInfo(data) {
    return axios.get("/platform/info/homeInfo", { params: data });
  },
  // 首页显示内容（新闻、政策法规)
  getArticleList(data) {
    return axios.get("/platform/info/content", { params: data });
  },
  // 文章详情
  getArticleDetail(data) {
    return axios.get(`/platform/info/contentById/${data.id}`);
  },
  //运量信息
  getTrafficInfo() {
    return axios.get("/platform/info/trafficInfo");
  },
  // 合同列表
  contractList(data) {
    return axios.get("/contract/list", { params: data });
  },
  // 合同归档
  contractArchive(data) {
    return axios.post("/contract/archive", data);
  },
  //运单详情----提交评价
  pushEvaluate(data) {
    return axios.post("/ythComment/commit", data);
  },
  // 查看安全学习内容列表
  adminSendRecordList(data) {
    return axios.post("/adminSendRecord/list", data);
  },
  // 签收
  adminSignForConfirmToSign(data) {
    return axios.post("/adminSignFor/confirmToSign", data);
  },
  // 转发学习资料
  adminSendRecordSend(data) {
    return axios.post("/adminSendRecord/send", data);
  },
  // 用户列表
  adminSignForUserList(data) {
    return axios.post("/adminSignFor/userList", data);
  },
  // 安全学习内容详情
  adminSendRecordDetails(data) {
    return axios.get("/adminSendRecord/details", { params: data });
  },
  // 签收情况
  signingSituation(data) {
    return axios.post("/adminSignFor/signingSituation", data);
  },
  // 查看试卷列表
  paperList(data) {
    return axios.post("/adminSendRecord/paperList", data);
  },
  // 查看试卷详情
  showSubject(data) {
    return axios.get("/ythStudy/showSubject", { params: data });
  },
  // 货主-运单管理-列表
  ownerWaybillTrackingList(data) {
    return axios.post("/yth/consignmentNote/customer/myOrder", data);
  },
  // 货主-运单管理-执行追踪
  ownerWaybillTracking(data) {
    return axios.post("/yth/consignmentNote/track", data);
  },

  // 查看答题详情
  scoreList(data) {
    return axios.post("/adminSendRecord/scoreList", data);
  },

  // 运单管理-货主统计分析-汇总报表
  customerTransportStatistics(data) {
    return axios.post("/reportForm/customerTransportStatistics", data);
  },
  // 货主/承运商 授信管理
  creditCondition(data) {
    return axios.get("/ythCustomer/creditCondition", { params: data });
  },
  // 删除地址
  deletePosition(data) {
    return axios.get("/ythCustomer/deletePosition", { params: data });
  },
  // 交易管理-统计分析
  subDemandTradeStatistics(data) {
    return axios.post("/subDemand/tradeStatistics", data);
  },
  // 合同管理-执行追踪
  // situationTrack(data) {
  //   return axios.post("/adminContract/situationTrack", data);
  // },
  customerContractTrack(data) {
    return axios.post("/contract/customerContractTrack", data);
  },
  // 货主：用户管理统计分析
  ownerStatistics(data) {
    return axios.post("/adminCustomer/pcStatistics", data);
  },
  // 货主：常用物料明细表
  itemStatistical(data) {
    return axios.get("/yth/consignmentNote/itemStatistical", { params: data });
  },
  // 货主：证件预警
  certificateWarning() {
    return axios.get("/ythCustomer/certificateWarning");
  },
  // 货主/承运商-子账户证件预警
  subCertificateWarning(data) {
    return axios.post("/ythCustomer/subCertificateWarning", data);
  },
  // 承运商/货主 :权限预警
  subAuthWarning(data) {
    return axios.post("/ythCustomer/subAuthWarning", data);
  },
  // 承运商/货主 :额度使用提醒
  quotaUsageReminder(data) {
    return axios.post("/app/message/messageList", data);
  },
  // 应付应收
  reconciliationPage(data) {
    return axios.post("/reconciliation/page", data);
  },
  // 货主退出平台申请
  ythCustomerApplyQuit(data) {
    return axios.get("/ythCustomer/applyQuit", { params: data });
  },
  // 货物类别运输 金额/数量 排名统计
  platformFormCategoryOfGoods(data) {
    return axios.post("/platformForm/CategoryOfGoods", data);
  },
  // 平台用户注册
  platformFormRegisterUserForm() {
    return axios.get("/platformForm/registerUserForm");
  },
  // 运输线路排名
  platformFormTransportRoute() {
    return axios.get("/platformForm/transportRoute");
  },
  // 车找货信息
  platformFormEmptyCarList(data) {
    return axios.get("/platformForm/emptyCarList", { params: data });
  },
  // 货找车信息
  platformFormGoodsSearchCar(data) {
    return axios.get("/platformForm/goodsSearchCar", { params: data });
  },
  // 货主交易统计分析报表
  customerTransactionStatistics(data) {
    return axios.post("/customerForm/transactionStatistics", data);
  },
  ...carriers,
  ...common,
  ...rebuild
};
export default http;
